/**
 * Page de changement de mot de passe obligatoire
 */

import { useState, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, authApi } from '@e-store/shared';
import './LoginPage.css';

export function ChangePasswordPage() {
  const navigate = useNavigate();
  const { user, refreshUser, logout } = useAuth();

  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');

    if (newPassword !== confirmPassword) {
      setError('Les mots de passe ne correspondent pas');
      return;
    }

    if (newPassword.length < 8) {
      setError('Le mot de passe doit contenir au moins 8 caractères');
      return;
    }

    setIsSubmitting(true);

    const response = await authApi.changePassword({
      currentPassword,
      newPassword,
    });

    if (response.error) {
      setError(response.error);
      setIsSubmitting(false);
      return;
    }

    await refreshUser();
    navigate('/dashboard');
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <h1>E-Store</h1>
          <h2>Changement de mot de passe</h2>
        </div>

        <div style={{
          background: '#fef3c7',
          border: '1px solid #fcd34d',
          borderRadius: '8px',
          padding: '16px',
          marginBottom: '20px'
        }}>
          <p style={{ margin: 0, color: '#92400e' }}>
            <strong>Bienvenue {user?.firstName} !</strong><br />
            Vous devez changer votre mot de passe temporaire.
          </p>
        </div>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="currentPassword">Mot de passe actuel</label>
            <input
              type="password"
              id="currentPassword"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="newPassword">Nouveau mot de passe</label>
            <input
              type="password"
              id="newPassword"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Minimum 8 caractères"
              required
              minLength={8}
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Confirmer</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="btn-primary" disabled={isSubmitting}>
            {isSubmitting ? 'Changement...' : 'Changer le mot de passe'}
          </button>
        </form>

        <div className="login-links">
          <button onClick={handleLogout} className="link" style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
            Se déconnecter
          </button>
        </div>
      </div>
    </div>
  );
}
